import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ClientInfoForm from './components/ClientInfoForm';
import CorporateInfoForm from './components/CorporateInfoForm';
import ContactInfoManager from './components/ContactInfoForm';
import BusinessForm from './components/BusinessForm';
import BankForm from './components/BankInfo';
import PricingForm from './components/PricingInfo';
import TermsAndConditionsForm from './components/TermsCondition';
import SignatureForm from './components/eSignature';
import VolumeForm from './components/VolumeForm';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import Login from './components/Login';
import Completed from './components/Completed';
import StepGuard from './components/StepGuard';
import { AuthProvider } from './components/StoreValue';

function App() {
    return (
        <Router>
             <AuthProvider>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Login />} /> {/* Default route */}
                <Route path="/ClientInfo" element={<StepGuard><ClientInfoForm /></StepGuard>} />
                <Route path="/CorporateInfo" element={<StepGuard><CorporateInfoForm /></StepGuard>} />
                <Route path="/ContactInfo" element={<StepGuard><ContactInfoManager /></StepGuard>} />
                <Route path="/BusinessInfo" element={<StepGuard><BusinessForm /></StepGuard>} />
                <Route path="/BankInfo" element={<StepGuard><BankForm /></StepGuard>} />
                <Route path="/PricingInfo" element={<StepGuard><PricingForm /></StepGuard>} />
                <Route path="/TermsAndConditions" element={<StepGuard><TermsAndConditionsForm /></StepGuard>} />
                <Route path="/eSignature" element={<StepGuard><SignatureForm /></StepGuard>} />
                <Route path="/VolumeInfo" element={<StepGuard><VolumeForm /></StepGuard>} />
                <Route path="/AboutUs" element={<AboutUs />} />
                <Route path="/ContactUs" element={<ContactUs />} />
                <Route path="/Completed" element={<StepGuard><Completed /></StepGuard>} />
                {/* Add other routes as needed */}
            </Routes>
           </AuthProvider>
        </Router>
    );
}

export default App;
